import {
  SvgIcon as MuiSvgIcon,
  SvgIconProps as MuiSvgIconProps,
} from '@mui/material';

interface SvgIconProps extends MuiSvgIconProps {
  name: string;
  className?: string;
}

export const SvgIcon = ({
  name,
  className,
  color = 'inherit',
  ...otherProps
}: SvgIconProps) => {
  return (
    <MuiSvgIcon color={color} {...otherProps}>
      <svg className={className} aria-hidden="true">
        <use xlinkHref={`#${name}`} />
      </svg>
    </MuiSvgIcon>
  );
};
